
import { defineComponent } from 'vue'

const VARIANTS = ['robin', 'juniper', 'cherry', 'aqua', 'honey'] as const

export default defineComponent({
  name: 'ZAvatarV2',
  props: {
    username: {
      type: String,
      required: true
    },
    variant: {
      type: String
    }
  },
  computed: {
    VARIANT_CLASSES() {
      return {
        [VARIANTS[0]]: 'bg-robin-500 border-robin-500 text-robin-500',
        [VARIANTS[1]]: 'bg-juniper-500 border-juniper-500 text-juniper-500',
        [VARIANTS[2]]: 'bg-cherry-500 border-cherry-500 text-cherry-500',
        [VARIANTS[3]]: 'bg-aqua-500 border-aqua-500 text-aqua-500',
        [VARIANTS[4]]: 'bg-honey-500 border-honey-500 text-honey-500'
      }
    },
    getVariantClasses() {
      return this.VARIANT_CLASSES[this.avatarVariantName as keyof typeof this.VARIANT_CLASSES]
    },
    avatarVariantName() {
      return (
        this.variant ||
        VARIANTS[
          typeof this.username === 'string'
            ? this.username.length % VARIANTS.length
            : Math.floor(Math.random() * VARIANTS.length)
        ]
      )
    }
  }
})
